module.exports = __webpack_public_path__ + "fonts/MrEavesModOT-Reg.52e93f18.woff2";